import { useNavigate } from 'react-router-dom';
import { ROUTES } from '../const/routes';
import { useSystemStore } from '../stores/SystemStore';
import { useIsMobileL } from './useBreakpoint';

export const useSetUserCardId = (): ((userId?: string) => void) => {
	const isMobile = useIsMobileL();
	const navigate = useNavigate();
	const setUserCardId = useSystemStore(state => state.setUserCardId);

	return (userId?: string) => {
		if (isMobile && userId) {
			navigate(`${ROUTES.APP.STUDENT_CARD}/${userId}`);
			return;
		}

		setUserCardId(userId);
	};
};
